import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  SEARCH_TILE: {
    GET_RECOMMENDED: (query) => ({ query }),
    API: {
      GET_RECOMMENDED: apiResourceActionCreator('recommendedResult')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/recommended${endpointQuery({ ...(query || {}) })}`, authToken, actions.searchTile.api.getRecommended)

export function* getRecommendedSearchTile(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload && action.payload.query));
}

const configuration = {
  name: 'getRecommended',
  action: actions,
  sagas: getRecommendedSearchTile,
  reducers: {
    request: (state, action) => {
      return Object.assign({}, state, {
        isFetching: true
      });
    },
    success: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        recommendedResult: action.payload.recommendedResult,
        error: null
      });
    },
    failed: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        isLoadingMore: false,
        error: action.payload.error
      });
    }
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/search-tile/configurations/getRecommended.js